import {Inject, Injectable} from '@angular/core';
import {API_URL} from "lib-base";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {IMedioRecepcion} from "../../shared/interfaces/pqrsdf";

@Injectable({
  providedIn: 'root'
})
export class MedioRecepcionService {

  private baseUrl: string ;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/medios-recepcion`;
  }


  getAll(): Observable<IMedioRecepcion[]> {
    const url = `${this.baseUrl}/public`;
    return this.http.get<IMedioRecepcion[]>(url);
  }
}
